import "./Iphone14.css";

function Iphone14() {
    return (
        <section className="iphone14 cursorP">
            <div className="container-fluid">
                <div className="iphone14-wrapper">
                    <div className="name1">iPhone 14</div>
                    <div className="name2">Big and bigger.</div>
                    <div className="links-blue">
                        <ul className="list-inline">
                            <li className="list-inline-item">
                                <a href="">Learn more</a>
                            </li>
                            <li className="list-inline-item">
                                <a href="">Buy</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Iphone14;
